var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmploymentIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 6,
    fill: "#EDEDED"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4167 21.6641H9.16667C8.24619 21.6641 7.5 20.9179 7.5 19.9974V8.33073C7.5 7.41025 8.24619 6.66406 9.16667 6.66406H20.8333C21.7538 6.66406 22.5 7.41025 22.5 8.33073V19.9974C22.5 20.9179 21.7538 21.6641 20.8333 21.6641H19.5833M15 20.8307C16.3807 20.8307 17.5 19.7114 17.5 18.3307C17.5 16.95 16.3807 15.8307 15 15.8307C13.6193 15.8307 12.5 16.95 12.5 18.3307C12.5 19.7114 13.6193 20.8307 15 20.8307ZM15 20.8307L15.0179 20.8306L12.3572 23.4912L10.0002 21.1342L12.5164 18.618M15 20.8307L17.6607 23.4912L20.0177 21.1342L17.5015 18.618M12.5 9.9974H17.5M10.8333 12.9141H19.1667",
    stroke: "#575756",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmploymentIcon);
export default __webpack_public_path__ + "static/media/EmploymentIcon.907fdae7c1393a07498684d81fdbcee9.svg";
export { ForwardRef as ReactComponent };